import { EasyIcon } from 'src/components'
import { getFileUrl } from 'enasops/utils/axios'

export default {
  download (ListTableContext: any, props: any) {
    const { LABEL, ICON, __RECORD__: record } = props.config
    const downloadUrl = getFileUrl(record.FILE_PATH ? JSON.parse(record.FILE_PATH)[0]?.FilePath : '') ?? ''

    return (
      <a download href={downloadUrl}>
        <EasyIcon type={ICON} size={16} />
        <span className='pd-l4'>{LABEL}</span>
      </a>
    )
  },
}